// extracted by mini-css-extract-plugin
export default {"wrapper":"us1jkpsuJlGBjuefhGNx","warningBlock":"Ynde3m_a7i_r14z59WYD","warningText":"wxCYw8aaDVhqoHpRek9_","warningCircleIcon":"E1U93kaaa43wJJToAACF"};